"use client";

import { Box, Typography } from "@mui/material";
import React from "react";
import { VideoData } from "@/types/dto/common/video";
import WistiaVideo from "@/components/shared/wistia-video/wistia-video";
import styles from "./styles.module.css";

interface RelatedVideoCardProps {
  item: VideoData;
  testId?: string;
  index?: number;
}

const RelatedVideoCard: React.FC<RelatedVideoCardProps> = ({ item, testId = "related-video-card", index }) => {
  const indexedTestId = `${testId}${index !== undefined ? `-${index}` : ""}`;

  return (
    <Box
      component="article"
      className={styles.relatedCard}
      data-testid={indexedTestId}
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Box
        data-testid={`${indexedTestId}-embed-container`}
        sx={{
          position: "relative",
          overflow: "hidden",
          borderTopLeftRadius: "2rem",
          borderTopRightRadius: "2rem",
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          paddingBottom: "56.25%",
          "& > div": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
          }
        }}
      >
        <WistiaVideo
          videoId={item.wistiaVideoId}
          title={item.title}
          deferUntilInteraction={false}
          className={styles.relatedVideoEmbed}
          testId={`${indexedTestId}`}
        />
      </Box>

    <Box
      data-testid={`${indexedTestId}-content`}
      sx={{
        backgroundColor: "background.cool_strong",
        borderBottomLeftRadius: "2rem",
        borderBottomRightRadius: "2rem",
        padding: "1rem 3.2rem",
        borderRadius: "0 0 2rem 2rem",
        display: "flex",
        alignItems: "center"
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" flexDirection="row">
        <Typography
          variant="subtitle_lg"
          component="h3"
          className={styles.subtitle1Custom}
          data-testid={`${indexedTestId}-title`}
        >
          {item.title}
        </Typography>
      </Box>
    </Box>
    </Box>
  );
};

export default RelatedVideoCard;
